/**
 * Istanti civili in Europe/Rome (non dipendono dal fuso del browser).
 * Usati per orebloccoprod / ORARIOPRODPANE nel planning.
 */

const ROME_TZ = 'Europe/Rome';

/** Cache leggera: mezzanotte Roma per YYYY-MM-DD (chiave stringa). */
const midnightCache = new Map();
const MIDNIGHT_CACHE_MAX = 64;

function trimMidnightCache() {
  if (midnightCache.size <= MIDNIGHT_CACHE_MAX) return;
  const it = midnightCache.keys();
  for (let i = 0; i < 16 && midnightCache.size > MIDNIGHT_CACHE_MAX / 2; i += 1) {
    const k = it.next().value;
    if (k != null) midnightCache.delete(k);
  }
}

function romeWallPartsFromUtcMs(ms) {
  const dtf = new Intl.DateTimeFormat('en-CA', {
    timeZone: ROME_TZ,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false,
  });
  const o = {};
  for (const p of dtf.formatToParts(new Date(ms))) {
    if (p.type !== 'literal') o[p.type] = p.value;
  }
  return {
    y: +o.year,
    mo: +o.month,
    d: +o.day,
    h: +o.hour,
    mi: +o.minute,
    s: +(o.second ?? 0),
  };
}

/**
 * Epoch ms dell’istante in cui a Roma sono le 00:00:00 del giorno civile `ymd` (YYYY-MM-DD).
 * Cerca nel range UTC sicuro attorno al giorno (gestisce DST).
 */
export function europeRomeMidnightUtcMs(ymd) {
  if (!ymd || typeof ymd !== 'string') return NaN;
  if (midnightCache.has(ymd)) return midnightCache.get(ymd);

  const [Y, M, D] = ymd.split('-').map(Number);
  if (!Number.isFinite(Y) || !Number.isFinite(M) || !Number.isFinite(D)) return NaN;

  const lo = Date.UTC(Y, M - 1, D - 2, 0, 0, 0, 0);
  const hi = Date.UTC(Y, M - 1, D + 2, 23, 59, 59, 999);

  for (let ms = lo; ms <= hi; ms += 60 * 1000) {
    const p = romeWallPartsFromUtcMs(ms);
    if (p.y === Y && p.mo === M && p.d === D && p.h === 0 && p.mi === 0 && p.s === 0) {
      midnightCache.set(ymd, ms);
      trimMidnightCache();
      return ms;
    }
  }

  for (let ms = lo; ms <= hi; ms += 1000) {
    const p = romeWallPartsFromUtcMs(ms);
    if (p.y === Y && p.mo === M && p.d === D && p.h === 0 && p.mi === 0 && p.s === 0) {
      midnightCache.set(ymd, ms);
      trimMidnightCache();
      return ms;
    }
  }

  return NaN;
}

/**
 * Epoch ms dell’istante “a Roma” = mezzanotte del `bakeYmd` + `prodMinutes` minuti dalla mezzanotte
 * (stesso modello di `new Date(y,m,d,H,mi)` con overflow su giorno successivo).
 *
 * @param {string} bakeYmd - YYYY-MM-DD (calendario gregoriano, come già usato nel planning)
 * @param {number} prodMinutes - minuti da mezzanotte (può superare 24h: si somma al timestamp)
 */
export function europeRomeBakeInstantUtcMs(bakeYmd, prodMinutes) {
  if (bakeYmd == null || prodMinutes == null || Number.isNaN(prodMinutes)) return NaN;
  const midnight = europeRomeMidnightUtcMs(bakeYmd);
  if (Number.isNaN(midnight)) return NaN;
  return midnight + prodMinutes * 60 * 1000;
}
